import { Component } from 'react'
import PropTypes from 'prop-types'
import debounce from 'lodash/debounce'
import isEqual from 'lodash/isEqual'

const time = 300

class EPLAutosave extends Component {
  static propTypes = {
    eplId: PropTypes.number,
    values: PropTypes.object,
    eplModel: PropTypes.object
  }

  shouldComponentUpdate (nextProps) {
    const { values } = this.props
    if (
      (!isEqual(nextProps.values.honorarium, values.honorarium) &&
        nextProps.values.honorarium !== 0) ||
      !isEqual(nextProps.values.fee, values.fee) ||
      !isEqual(nextProps.values.credits, values.credits)
    ) {
      return false
    }
    if (!isEqual(nextProps.values, values)) {
      this.props.eplModel.eplValuesBeingUpdated = true
      this.commit()
    }
    return false
  }

  commit = debounce(() => {
    const { eplId, values, eplModel } = this.props
    eplModel.autosave(eplId, values)
  }, time)

  render () {
    return null
  }
}

export default EPLAutosave
